<template>
  <div v-if="order" class="row">
    <div class="col-sm-6 col-xs-12">
      <div v-if="receipt">
        <label class="control-label font-weight-bold mr-2">Fecha: </label>
        <span>{{ receipt.createdAt }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">Código del Pedido: </label>
        <span>{{ order.code }}</span>
      </div>

      <div v-if="receipt" class="my-2">
        <label class="control-label font-weight-bold mr-2" :class="{ 'd-block': edit }"
          >Cotización de Dólar (RCP):
        </label>

        <div v-if="edit" class="form-group">
          <!-- TODO validation -->
          <el-input
            v-model="form.dollarQuotation"
            v-validate="'required_if:${!this.edit}, decimal: true'"
            name="dollarQuotation"
            type="number"
            class="mr-2"
            :disabled="quotationDisabled"
          >
            <base-button
              slot="append"
              class="rounded-0"
              type="primary"
              size="sm"
              :disabled="quotationDisabled"
              @click="getQuotation"
            >
              Cotizar
            </base-button>
          </el-input>

          <small v-show="dollarQuotation.invalid" class="text-danger">
            {{ errors.first('dollarQuotation') }}
          </small>
        </div>
        <span v-else>{{ receipt.dollarQuotation }}</span>
      </div>
    </div>

    <div v-if="order.producer" class="col-sm-5 offset-sm-1 col-xs-12">
      <div v-if="order.producer.distributor.seller">
        <label class="control-label font-weight-bold mr-2">Asesor Técnico: </label>
        <span>{{ order.producer.distributor.seller.name }}</span>
      </div>
      <div v-if="order.producer.distributor">
        <label class="control-label font-weight-bold mr-2">Distribuidor: </label>
        <span>{{ order.producer.distributor.name }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">Productor: </label>
        <span>{{ order.producer.businessName }}</span>
      </div>

      <div class="mt-2">
        <label class="control-label font-weight-bold mr-2">Total en dolares: </label>
        <span>{{ order.total | toCurrencyUSD }}</span>
      </div>

      <div class="mt-2">
        <label class="control-label font-weight-bold mr-2">Cot. de Dólar Pedido: </label>
        <span>{{ order.dollarQuote | decimals }}</span>
      </div>

      <div class="mt-2">
        <label class="control-label font-weight-bold mr-2">Total Pedido en Pesos: </label>
        <span>{{ order.totalInPesos | toCurrencyARS }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import OrdersService from '@/services/resources/orders.service';

export default {
  props: {
    receipt: {
      type: Object,
      default: null,
    },

    order: {
      type: Object,
      default: null,
    },

    edit: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        dollarQuotation: 0,
      },

      modelValidations: {
        dollarQuotation: {
          required_if: true,
          decimal: true,
        },
      },
    };
  },

  mounted() {
    if (this.edit) {
      this.form.dollarQuotation = this.receipt.dollarQuotation;
    }
  },

  computed: {
    ...mapFields(['dollarQuotation']),

    quotationDisabled() {
      return (
        this.order.state.name === OrdersService._STATE_TO_LIQUIDATE ||
        this.order.state.name === OrdersService._STATE_FINALIZED
      );
    },
  },

  methods: {
    async getQuotation() {
      try {
        await this.$validator.validateAll();

        this.$emit('get-quotation', this.form.dollarQuotation);
      } catch (err) {}
    },
  },
};
</script>

<style scoped>
::v-deep .el-input-group__append {
  padding: 0;
}

::v-deep .el-input-group__append button {
  padding: 12px;
  margin: -10px 0;
  line-height: 1.2;
  outline: none;
}
</style>
